<div class="loading-icon"></div>
<div class="loading-text">{{loadingText}}</div>